import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-placanja-tables',
  templateUrl: './placanja-tables.component.html',
  styleUrls: ['./placanja-tables.component.scss']
})
export class PlacanjaTablesComponent implements OnInit {
  /** I/O */
  @Input() samoNeplaceni: boolean | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
